import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/fuegodocs/theme/src/components/Layout/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ResourcesList = makeShortcode("ResourcesList");
const ResourceLink = makeShortcode("ResourceLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Use as a drop-in replacement for radio buttons in Atlassian products.`}</p>
    <p>{`Extends the `}<a parentName="p" {...{
        "href": "/react/primitives/radio"
      }}>{`Fuegokit Radio ARIA primitive`}</a>{`.`}</p>
    <p>{`Provides all props developers need in Atlassian product environments, styles for various needs, normalized behavior across different platforms and devices, and consistent keyboard focus behavior.`}</p>
    <h2>{`Import`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {AtlasRadio} from '@fuegokit/react'
`}</code></pre>
    <h2>{`Accessibility`}</h2>
    <p>{`Radio buttons should always be accompanied by a corresponding `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` to improve support for assistive technologies.`}</p>
    <h2>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<AtlasRadio label={\`Huey\`} name={'Huey'} value={\`Huey\`} isChecked />
`}</code></pre>
    <h2>{`See also`}</h2>
    <ResourcesList mdxType="ResourcesList">
  <ResourceLink href={`/getting-started/theming-api`} mdxType="ResourceLink">Theming API</ResourceLink>
  <ResourceLink href={`/primitives/radio`} mdxType="ResourceLink">Radio</ResourceLink>
  <ResourceLink href={`/screens/getting-started-page`} mdxType="ResourceLink">Getting Started page</ResourceLink>
    </ResourcesList>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      